import { saveVoucherInfo } from '@shared/redux/actions';

import { HOTEL_VOUCHER } from '@shared/helpers/routes';

import { bookingReserve } from '@shared/services/services';

import { BOOKING_ERROR_TYPES } from '@shared/constants/bookingErrors';
import { buildTrackingData, trackEvent } from '../helpers/bookingFlow';

export async function sendBookingForm({
  baseBookingBody,
  subsidiary,
  id_integration,
  detailTransaction,
  passengerDetails,
  search,
  hotelDetails,
  user,
  dispatch,
  history,
  seller,
  total,
  room,
  price,
  cancelationFee,
  validate,
}) {
  const bookingReserveBody = {
    ...baseBookingBody,
    id_entity: subsidiary.id,
    id_transaction: room.id_transaction,
    branch_payment: true,
  };

  const name = `${passengerDetails?.[0]?.description || ''} ${
    passengerDetails?.[1]?.description || ''
  }`.trim();

  const eventData = buildTrackingData({
    metodo_pago: 'sucursal',
    subsidiary,
    search,
    pricesDetail: total,
    hotelDetails,
    passenger_email: baseBookingBody?.passenger_email,
    checkIn: baseBookingBody?.checkIn,
  });

  const baseVoucherInfo = {
    email: baseBookingBody.passenger_email,
    name,
    id_integration,
    hotelDetailsPay: hotelDetails,
    hotelDetails,
    search,
    searchPay: search,
    subsidiary,
    seller,
    total,
    room,
    price,
    cancelationFee,
    validate,
  };

  dispatch(saveVoucherInfo({ bookingResponse: null }));

  try {
    const resultBookingReserve = await bookingReserve(
      bookingReserveBody,
      id_integration,
      detailTransaction
    );

    const voucherInfo = {
      ...baseVoucherInfo,
      bookingResponse: resultBookingReserve,
      pagos: false,
      bookingError: false,
    };

    dispatch(saveVoucherInfo(voucherInfo));

    trackEvent({
      eventName: 'reservaHotels',
      trackingValue: { value: eventData },
      user,
    });

    history.push({ pathname: HOTEL_VOUCHER, state: { ...voucherInfo } });
  } catch (error) {
    console.error('bookingb2b error', error);

    const voucherInfo = {
      ...baseVoucherInfo,
      bookingResponse: error.response?.data?.details,
      pagos: false,
      bookingError: true,
      errorType: error?.type ?? BOOKING_ERROR_TYPES.GENERIC,
      errorMessage: error?.message,
      cancelationFee,
      validate,
    };

    dispatch(saveVoucherInfo(voucherInfo));

    trackEvent({
      eventName: 'reservaHotels',
      trackingValue: { value: { ...eventData, error } },
      user,
    });

    history.push({ pathname: HOTEL_VOUCHER, state: { ...voucherInfo } });
  }
}
